/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import ComplicationSelector from "@ls/grouping-complication-selector";
import TradeTrackingErrorSelectorComplication from "./TradeTrackingErrorSelectorComplication";
import TradeTrackingErrorDefinition from "state/tte/TradeTrackingErrorDefinition";
import { useDispatch, useSelector } from "react-redux";
import { selectDefinitions } from "state/tte/selectors";
import SelectionState from "state/selections/SelectionState";
import { setDefinition as setTteDefinitions } from "state/tte/actions";

const TradeTrackingErrorSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setTteDefinitions(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={TradeTrackingErrorDefinition.getDefault}
      ComplicationComponent={TradeTrackingErrorSelectorComplication}
      btnTitle={"Trade Tracking Error"}
      addMoreText={"Trade Tracking Error Column"}
    />
  );
};
export default memo(TradeTrackingErrorSelector);
